(function () {
  'use strict';

  var section = document.querySelector('.bb-section');
  if (!section) return;

  var THRESHOLD = parseInt(section.dataset.threshold || '29000', 10); // cents
  var rows = Array.from(section.querySelectorAll('.bb-row'));
  var totalEl = document.getElementById('bb-total');
  var addBtn = document.getElementById('bb-add-btn');
  var addBtnText = addBtn.querySelector('.bb-add-btn__text');
  var addBtnSpinner = addBtn.querySelector('.bb-add-btn__spinner');
  var shippingBar = document.getElementById('bb-shipping-bar');
  var shippingText = document.getElementById('bb-shipping-text');
  var shippingFill = document.getElementById('bb-shipping-fill');
  var successEl = document.getElementById('bb-success');

  var cartTotal = 0; // סה"כ סל קיים באגורות
  var cartIndicatorEl = null;

  var quantities = {};
  rows.forEach(function (row) {
    quantities[row.dataset.variantId] = 0;
  });

  function getPrice(row) {
    return parseInt(row.dataset.price, 10);
  }

  function getQty(row) {
    return quantities[row.dataset.variantId] || 0;
  }

  function formatMoney(cents) {
    return '₪' + Math.round(cents / 100);
  }

  function updateRow(row) {
    var qty = getQty(row);
    var lineTotal = qty * getPrice(row);
    row.querySelector('.bb-qty-value').textContent = qty;
    row.querySelector('.bb-row__line-amount').textContent = qty > 0 ? formatMoney(lineTotal) : '₪0';
    row.querySelector('[data-action="decrease"]').disabled = qty === 0;
    row.classList.toggle('bb-row--active', qty > 0);
  }

  function getBundleTotal() {
    return rows.reduce(function (sum, row) {
      return sum + getQty(row) * getPrice(row);
    }, 0);
  }

  function renderCartIndicator() {
    if (cartTotal <= 0) return;
    if (cartIndicatorEl) return; // already rendered

    cartIndicatorEl = document.createElement('p');
    cartIndicatorEl.className = 'bb-cart-indicator';
    cartIndicatorEl.textContent = 'כבר בסל: ' + formatMoney(cartTotal);
    // Insert as first child of shipping bar, before the text line
    shippingBar.insertBefore(cartIndicatorEl, shippingBar.firstChild);
  }

  function updateShippingBar() {
    var bundleTotal = getBundleTotal();
    var combined = cartTotal + bundleTotal;

    if (combined >= THRESHOLD) {
      shippingBar.classList.add('bb-shipping-bar--free');
      shippingFill.style.width = '100%';
      shippingText.textContent = '🎉 זכית במשלוח חינם!';
    } else {
      shippingBar.classList.remove('bb-shipping-bar--free');
      shippingFill.style.width = Math.min((combined / THRESHOLD) * 100, 100) + '%';
      var remaining = THRESHOLD - combined;
      if (combined === 0) {
        shippingText.textContent = 'הוסיפו מוצרים לקבלת משלוח חינם מעל ' + formatMoney(THRESHOLD);
      } else {
        shippingText.textContent = 'נותרו ' + formatMoney(remaining) + ' למשלוח חינם';
      }
    }
  }

  function updateSummary() {
    var bundleTotal = getBundleTotal();
    totalEl.textContent = formatMoney(bundleTotal);
    addBtn.disabled = bundleTotal === 0;
    updateShippingBar();
  }

  // Image click to increase quantity
  section.addEventListener('click', function (e) {
    var img = e.target.closest('.bb-row__image');
    if (img) {
      var row = img.closest('.bb-row');
      var increaseBtn = row.querySelector('[data-action="increase"]');
      if (increaseBtn) {
        increaseBtn.click();
        return;
      }
    }
  });

  // Qty button clicks via event delegation
  section.addEventListener('click', function (e) {
    var btn = e.target.closest('.bb-qty-btn');
    if (!btn) return;

    var row = btn.closest('.bb-row');
    var vid = row.dataset.variantId;
    var action = btn.dataset.action;

    if (action === 'increase') {
      quantities[vid] = (quantities[vid] || 0) + 1;
    } else if (action === 'decrease') {
      quantities[vid] = Math.max(0, (quantities[vid] || 0) - 1);
    }

    updateRow(row);
    updateSummary();
  });

  // Add to cart
  addBtn.addEventListener('click', function () {
    var items = rows
      .filter(function (row) { return getQty(row) > 0; })
      .map(function (row) {
        return { id: parseInt(row.dataset.variantId, 10), quantity: getQty(row) };
      });

    if (!items.length) return;

    addBtn.disabled = true;
    addBtnText.style.display = 'none';
    addBtnSpinner.style.display = 'inline-block';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart error');
        return r.json();
      })
      .then(function () {
        addBtnSpinner.style.display = 'none';
        successEl.style.display = '';
        setTimeout(function () { window.location.href = '/cart'; }, 900);
      })
      .catch(function () {
        addBtn.disabled = false;
        addBtnText.style.display = '';
        addBtnSpinner.style.display = 'none';
        alert('שגיאה בהוספה לסל. אנא נסו שנית.');
      });
  });

  // Init: שולף את מצב הסל הקיים לפני רינדור
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      cartTotal = cart.items_subtotal_price || 0;
      renderCartIndicator();
      rows.forEach(updateRow);
      updateSummary();
    })
    .catch(function () {
      // המשך גם אם שליפת הסל נכשלה
      rows.forEach(updateRow);
      updateSummary();
    });
})();
